import React from "react";
import { AiOutlineRight } from "react-icons/ai";
import styled from "styled-components";

interface ButtonProps {
  color: string;
}

const ProductTag = (props: any) => {
  const { className, name, color } = props;
  return (
    <Button className={className} color={color}>
      <span>{name}</span>
      <AiOutlineRight className="arrow" />
    </Button>
  );
};

const Button = styled.button<ButtonProps>`
  width: fit-content;
  max-width: 140px;
  white-space: pre-line;
  background: ${(p) => p.color};
  border-radius: 4px;
  font-family: HelveticaNeue-Light;
  font-size: 12px;
  justify-content: space-between;
  align-items: center;
  color: #fbfbfb;
  line-height: 16px;
  overflow: ellipsis;
  display: flex;
  cursor: pointer;
  text-align: left;
  border-color: transparent;
  transition: 0.2s ease-in;

  span {
    margin: 0.4rem 10px 0.4rem 0;
  }

  .arrow {
    width: 30px;
  }
`;

export default ProductTag;
